import React from "react";
import ReactDOM from "react-dom";
import { AppContainer } from "react-hot-loader";
import { initializeApplication } from "./initialization";
import * as Sentry from "@sentry/browser";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: process.env.SENTRY_URL
  });
}

const render = (
  Component: typeof React.Component,
  rootElement: HTMLElement
) => {
  ReactDOM.render(
    <AppContainer>
      <Component />
    </AppContainer>,
    rootElement
  );
};

initializeApplication()
  .then(Root => {
    const rootElement = document.getElementById("root");
    if (!rootElement) {
      throw new Error("Not found element with root id");
    }

    render(Root, rootElement);
  })
  .catch(err => {
    Sentry.captureException(err);
  });
